import type { EnrichedParticipants } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { isAmericanEventType } from '@swf/sports/types/americanEventType';
import type { EventTypeId } from '@swf/sports/types/eventType';

import { TXTWCL_N0_vs_N1 } from './Participants.messages.json';
import styles from './Participants.scss';

interface Props {
  eventName: string;
  eventTypeId: EventTypeId;
  enrichedParticipants?: EnrichedParticipants;
}

const Participants = ({ eventName, eventTypeId, enrichedParticipants }: Props) => {
  if (!enrichedParticipants) return null;

  return (
    <div className={styles.participants} data-testid="event-participants">
      {isAmericanEventType(eventTypeId) && eventName.includes('@') ? (
        <>
          <span className={styles.americanFirstParticipant}>
            <span className={styles.participant}>{enrichedParticipants[0].participant}</span>
            <span>{' @ '}</span>
          </span>
          <span className={styles.participant}>{enrichedParticipants[1].participant}</span>
        </>
      ) : (
        <>
          <span className={styles.participant}>
            {enrichedParticipants[0].participant}
            <span className={styles.srOnly}>
              <Translation {...TXTWCL_N0_vs_N1} values={{ 0: '', 1: '' }} />
            </span>
          </span>
          <span className={styles.participant}>{enrichedParticipants[1].participant}</span>
        </>
      )}
    </div>
  );
};

export default Participants;
